import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <footer className='py-5'>
            <div className="container">
                <h5 className='fw-bold m-0 text-white text-center' ><small>&copy; Corporate Sales Trainer || Alrights reserved by Bipu {new Date().getUTCFullYear()} </small></h5>
            </div>
        </footer>
    );
};

export default Footer;